<div class="table" [style]="{ height: scrollable() ? '100%' : 'auto' }">
  <div class="{{ theme }} list-table-container" [style]="{ width: config.width ?? '100%', height: scrollable() ? '100%' : 'auto' }">
    <p-table
      #table
      styleClass="responsive-table"
      responsiveLayout="scroll"
      [selectAll]="selectAll()"
      (selectAllChange)="selectAll.set($event.checked)"
      [scrollable]="scrollable()"
      [scrollHeight]="scrollHeight()"
      [value]="visibleData"
      [loading]="_loading"
      [showLoader]="false"
      [selection]="selectedData()"
      (selectionChange)="selectedData.set($event)"
      (onRowSelect)="triggerSelect($event)"
      (onRowUnselect)="triggerSelect($event, 'removed')"
      (onHeaderCheckboxToggle)="triggerSelect($event)"
      (sortFunction)="sortList($event)"
      [customSort]="true"
      [resizableColumns]="true"
      columnResizeMode="expand"
      [reorderableColumns]="true"
      [reorderableRows]="true"
      [columns]="_cols()"
      (onColReorder)="reorderCol($event)"
      (onColResize)="resizeCol($event)">
      <!-- Header { -->
      <ng-template pTemplate="header" let-columns>
        <tr [class.noSelect]="!config.selectable" [class.selected]="selectedData().length === _data.length">
          @if (config.selectable) {
            <th class="select-th">
              @if (tableSelectedHeader()) {
                <div class="header-cell">
                  <span>{{ tableSelectedHeader()! | translate }}</span>
                </div>
              } @else {
                <p-tableHeaderCheckbox [disabled]="disabledSelection()"></p-tableHeaderCheckbox>
              }
            </th>
          }
          @if (reorderableRows() || config.reorderableRows) {
            <th class="reorder-th" style="width: 3rem">
              <div class="header-cell">
                <!-- Empty header for drag handle column -->
              </div>
            </th>
          }
          @for (col of columns; track col.id; let index = $index; let last = $last) {
            @if (!col.hidden && !col?.actions?.length) {
              <th
                [pSortableColumn]="col?.sort"
                id="tbr-{{ col.id }}"
                [style]="{
                  width: col?.width ? col.width + 'px' : 'auto',
                  maxWidth: col?.noTruncate ? 'none' : col?.width ? col.width + 'px' : '200px',
                }"
                pResizableColumn
                pReorderableColumn>
                <div class="header-cell">
                  <span>{{ col?.label | translate }}</span>
                  @if (col?.sort) {
                    <p-sortIcon [field]="col?.sort"></p-sortIcon>
                  }
                </div>
              </th>
            }
            <!-- Actions Columns           -->
            @if (last && !!col?.actions?.length) {
              <th id="tbr-{{ col.id }}" pFrozenColumn>
                <div class="header-cell">
                  @if (col.label) {
                    <span>{{ col.label | translate }}</span>
                  } @else {
                    <div class="header-cell gap-2">
                      <sxw-table-column-toggle [(columns)]="_cols" />
                    </div>
                  }
                </div>
              </th>
            }
          }
        </tr>
      </ng-template>
      <!-- } Header -->

      <ng-template #checkboxicon let-checked>
        @if (checked) {
          <div class="checkbox-selected">
            <sxw-svg-icon name="checked" width="15" height="15" fillColor="white"></sxw-svg-icon>
          </div>
        }
      </ng-template>

      <!-- Body { -->
      <ng-template pTemplate="body" let-row let-columns="columns" let-index="rowIndex">
        @if (!_loading) {
          <tr
            [class]="row.__class"
            [class.noSelect]="!config.selectable"
            [class.selected]="isSelectedRow(row)"
            [attr.data-row-index]="index"
            (dragover)="onDragOver($event, row)"
            (drop)="onDrop($event, index)"
            [class.drag-over]="row.__dragOver"
            [class.being-dragged]="row.__dragging">
            @if (config.selectable) {
              <td class="select-td">
                @if (config.selectable === "multiple") {
                  <p-tableCheckbox [disabled]="disabledSelection()" [hidden]="hideAllRowsSelection()" [value]="row"></p-tableCheckbox>
                }
                @if (config.selectable === "single") {
                  <p-tableRadioButton [disabled]="disabledSelection()" [hidden]="hideAllRowsSelection()" [value]="row"></p-tableRadioButton>
                }
              </td>
            }
            @if (reorderableRows() || config.reorderableRows) {
              <td class="reorder-td">
                <div
                  class="drag-handle-wrapper"
                  [title]="'COMMON.DRAG_TO_REORDER' | translate"
                  draggable="true"
                  (dragstart)="onDragStart($event, index, row)"
                  (dragend)="onDragEnd($event, row)">
                  <sxw-svg-icon name="dots-grid" width="18" height="18" fillColor="var(--p-gray-400)" class="drag-handle"> </sxw-svg-icon>
                </div>
              </td>
            }
            @for (col of _cols(); track col.id; let i = $index) {
              @if (!col.hidden) {
                <td
                  [style.width]="col?.width ? col.width + 'px' : 'auto'"
                  [style.max-width]="col?.noTruncate ? 'none' : col?.width ? col.width + 'px' : '200px'"
                  [style]="col.styles"
                  [class]="'td-' + i"
                  [class]="col.classes"
                  [class.no-truncate]="col.noTruncate">
                  <ng-container *ngTemplateOutlet="col.html ? htmlCell : simpleCell; context: { col, row: row['__formatted__'], index }">
                  </ng-container>
                  <!-- Actions { -->
                  @if (col.actions) {
                    <ng-container [ngTemplateOutlet]="actionsTemplate" [ngTemplateOutletContext]="{ col, data, index }" />
                  }
                  <!--  } Actions      -->

                  <!-- Components {         -->
                  @for (comp of col.components; track $index) {
                    <ng-template
                      dynamicChildLoader
                      [component]="comp.component"
                      [inputs]="comp.inputs"
                      [outputs]="comp.outputs"
                      [row]="row"
                      [visible]="comp.visible" />
                  }
                  <!-- } Components          -->
                </td>
              }
            }
          </tr>
        }
      </ng-template>
      <!-- } Body -->

      <!-- Loading { -->
      <ng-template pTemplate="loadingbody">
        @for (i of [1, 2, 3, 4, 5]; track $index) {
          <tr class="loading-row">
            <!--   Hide Skeleton for checkbox for now and add some padding to fill the space      -->
            @if (config.selectable) {
              <td>
                <p-skeleton width="1.5rem" borderRadius="50%" height="1.5rem"></p-skeleton>
              </td>
            }
            @if (reorderableRows() || config.reorderableRows) {
              <td>
                <p-skeleton width="1rem" borderRadius="50%" height="1rem"></p-skeleton>
              </td>
            }
            <!--   .............................................................................................       -->
            @for (col of _cols(); track col.id) {
              @if (!col.hidden) {
                <td [style.width]="col.width ?? config.fixedWidth ?? 'auto'">
                  <div>
                    <p-skeleton width="100%" borderRadius="30px" height="1.5rem"></p-skeleton>
                  </div>
                </td>
              }
            }
          </tr>
        }
      </ng-template>
      <!-- } Loading  -->

      <ng-template #sorticon let-order>
        @if (order === 0) {
          <sxw-svg-icon name="sort-up-down" width="16" height="16" strokeColor="var(--p-gray-400)" />
        } @else if (order === 1) {
          <sxw-svg-icon name="sort-up" width="16" height="16" strokeColor="var(--p-gray-400)" />
        } @else {
          <sxw-svg-icon name="sort-down" width="16" height="16" strokeColor="var(--p-gray-400)" />
        }
      </ng-template>

      <ng-template #emptymessage let-columns>
        <tr class="alternative-body-container">
          <!--          columns.length + additional columns (selectable + reorderable) -->
          @if (!_errored && !_loading && (!visibleData || !visibleData.length)) {
            <td
              class="no-results-container"
              [colSpan]="columns.length + (!!config.selectable ? 1 : 0) + (reorderableRows() || config.reorderableRows ? 1 : 0)">
              <img class="no-data-icon" src="/kernel/icons/no-data.svg" alt="" />
              <h1 class="no-data-title">{{ "COMMON.NO_RESULTS" | translate }}</h1>
              @if (noDataPage()) {
                <a class="create-data-button" [routerLink]="noDataPage()"><i class="pi pi-plus"></i>{{ "addNew" | translate }}</a>
              }
            </td>
          }
          @if (_errored) {
            <td
              class="error-container"
              [colSpan]="columns.length + (!!config.selectable ? 1 : 0) + (reorderableRows() || config.reorderableRows ? 1 : 0)">
              <img class="error-icon" src="/kernel/icons/connection-bug.svg" alt="" />
              <h1 class="error-title">Something Went Wrong</h1>
              <span class="error-reload-button" (click)="reload()"><i class="pi pi-refresh"></i> Reload The Table</span>
            </td>
          }
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<!--  Cell Templates {    -->
<ng-template #simpleCell let-col="col" let-row="row" let-index="index">
  <span
    class="simple-cell"
    [class.clickable]="!!config.onCellClick"
    (click)="handleCellClick(index)"
    (keydown.enter)="config.onCellClick ? handleCellClick(index) : null"
    (keydown.space)="config.onCellClick ? handleCellClick(index) : null"
    [tabindex]="config.onCellClick ? 0 : -1">
    {{ row[col?.id ?? ""] }}
  </span>
</ng-template>
<ng-template #htmlCell let-col="col" let-row="row"><span [innerHTML]="row[col?.id ?? '']"></span></ng-template>
<!-- } Cell Templates -->

<!-- Action Template { -->
<ng-template #actionsTemplate let-col="col" let-data="data" let-index="index">
  <div class="actions">
    @for (action of col.actions; track action.id) {
      @if (!action?.actions?.length) {
        <sxw-table-action class="single-action" [style]="action?.styles" [action]="action" [index]="index" [data]="data"></sxw-table-action>
      } @else if ((hiddenActions.get(action)?.size ?? 0) < action?.actions?.length) {
        <button class="multiple-actions" (click)="overlay.popover.toggle($event)">
          <sxw-svg-icon
            name="ellipsis"
            width="16"
            height="16"
            fillColor="var(--p-gray-400)"
            strokeColor="var(--p-gray-400)"
            [class]="{ active: data?.[index]?.__actionsListActive }" />
        </button>
        <sxw-overlay-panel #overlay (onHide)="toggleActionsList(index, false)" (onShow)="toggleActionsList(index, true)">
          <sxw-overlay-menu-list [title]="'COMMON.ACTIONS.SELECT_ACTION'" [items]="action.actions" dataKey="id" class="actions-list">
            <ng-template #menuItem let-subAction="item">
              <sxw-overlay-menu-item>
                <ng-template #menuItem>
                  <sxw-table-action
                    (visibleChange)="handleActionVisibilityChange(subAction, action, $event)"
                    class="item"
                    [style]="subAction?.styles"
                    [action]="subAction"
                    [index]="index"
                    [data]="data" />
                </ng-template>
              </sxw-overlay-menu-item>
            </ng-template>
          </sxw-overlay-menu-list>
        </sxw-overlay-panel>
      }
    }
  </div>
</ng-template>
<!-- } Action Template -->

<ng-template #actionMenu let-action let-index></ng-template>
